import React from 'react';
import ClassAssembly  from 'views/ClassAssesmbly5E2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;